import {Component, EventEmitter, Input, Output} from '@angular/core';
import {InvoiceSettingDto} from "../../../../Model/Dto/InvoiceSettingDto";
import {LoginService} from "../../../../Services/login.service";
import {AiPromptsService} from "../../../../Services/aiprompt.service";
import {SystemService} from "../../../../Services/system.service";
import {TemplateService} from "../../../../Services/template.service";
import {InvoiceService} from "../../../../Services/invoice.service";
import {lastValueFrom} from "rxjs";
import {fieldNames} from 'app/Model/FieldNames';

export interface DescriptionWizardItem {
  name: string;
  group: string;
}

@Component({
  selector: 'np-description-wizard-field-chooser',
  templateUrl: './description-wizard-field-chooser.component.html',
})
export class DescriptionWizardFieldChooserComponent {
  @Input() field: string;
  @Output() fieldChange = new EventEmitter<string>();


  selectedField: DescriptionWizardItem;
  resultExcelFields: DescriptionWizardItem[] = [
    {name: fieldNames.descriptionShort, group: 'Product'},
    {name: fieldNames.descriptionLong, group: 'Product'},
    {name: fieldNames.keywords, group: 'Product'},
    {name: fieldNames.metaTitel, group: 'Meta'},
    {name: fieldNames.metaDescription, group: 'Meta'},
    {name: fieldNames.line1, group: 'Wawi'},
    {name: fieldNames.line2, group: 'Wawi'},
    {name: fieldNames.line3, group: 'Wawi'},
    {name: fieldNames.line4, group: 'Wawi'},
    {name: fieldNames.weight, group: 'Logistik'},
    {name: fieldNames.lenght, group: 'Logistik'},
    {name: fieldNames.width, group: 'Logistik'},
    {name: fieldNames.depth, group: 'Logistik'}
  ];
  resultExcelFieldGroups: string[] = ['Product', 'Meta', 'Wawi', 'Logistik'];
  relevantResultExcelFields: DescriptionWizardItem[];

  onGroupValueChanged(event: any) {
    this.relevantResultExcelFields = this.resultExcelFields.filter((x) => x.group == event.value);
  }

}
